import { Themes } from '../../style/theme-consts';

export const ModalModes = {
  LIGHT: Themes.LIGHT,
  DARK: Themes.DARK
};
